import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'

import { actions as LKModalActions } from 'shared/LKModal'
import { getLKGrid, destroy as destroyGrid } from '../../shared/LKGrid'
import { getInfoPage, getTabLoadingState, getErrors } from '../selectors'
import { clearErrors, unregisterById } from '../actions'
import { DetailsGridPrefixes } from '../constants'
import { memorizedParams } from '../helpers'

const prefixesByType = {
  Application: DetailsGridPrefixes.application,
  Client: DetailsGridPrefixes.client,
  Loan: DetailsGridPrefixes.loan,
  Collateral: DetailsGridPrefixes.collateral,
  Order: DetailsGridPrefixes.order,
  AccountStatement: DetailsGridPrefixes.statement,
  Account: DetailsGridPrefixes.account,
}

function mapStateToProps(state, payload) {
  const { ID, type, tabs, baseTabId } = memorizedParams(payload)
  const page = Array.isArray(tabs()[baseTabId].api) ? ['base'] : tabs()[baseTabId].api

  return {
    data: getInfoPage(state, { type, ID, page }),
    loading: getTabLoadingState(state, { type, ID, page }),
    error: getErrors(state, { type, ID }),
    grids: getLKGrid(state),
  }
}

function mapDispatchToProps(dispatch, { ID, type, onClose, history, openContext }) {
  return {
    clearErrors: (modalName) => {
      const isModal = openContext === 'modal'

      if (onClose) {
        onClose()
      }

      if (isModal) {
        dispatch(LKModalActions.close(modalName))
      } else {
        history.push('/')
      }

      dispatch(clearErrors())
      dispatch(unregisterById(type, ID))
    },

    destroyGrids: (grids) => () => {
      const prefix = prefixesByType[type]
      if (prefix) {
        Object.keys(grids)
          .filter((instanceName) => instanceName.includes(prefix))
          .forEach((instanceName) => dispatch(destroyGrid(instanceName)))
      }
    },

    openErrorModal: (message) => dispatch(LKModalActions.openError(message)),
  }
}

const mergeProps = ({ grids, ...rest }, dispatchProps, ownProps) => ({
  ...ownProps,
  ...rest,
  ...dispatchProps,
  destroyGrids: dispatchProps.destroyGrids(grids),
})

const connectEnhancer = connect(mapStateToProps, mapDispatchToProps, mergeProps)

export default compose(withRouter, connectEnhancer)
